import { useAppStore } from "@/store";

function parseReleaseTime(release: string): Date {
  if (!/^\d{12}$/.test(release)) {
    throw new Error("Invalid release format");
  }

  const year = 2000 + parseInt(release.slice(0, 2)); // "25" -> 2025
  const month = parseInt(release.slice(2, 4)) - 1;   // JS months are 0-based
  const day = parseInt(release.slice(4, 6));
  const hour = parseInt(release.slice(6, 8));
  const minute = parseInt(release.slice(8, 10));
  const second = parseInt(release.slice(10, 12));

  return new Date(year, month, day, hour, minute, second);
}


export function isAfter(current: string, target: string) {
  const currentDate = parseReleaseTime(current);
  const targetDate = parseReleaseTime(target);

  return currentDate.getTime() >= targetDate.getTime();
}

export function isSupportedOn(target: string) {
  const currentVersion = useAppStore(state => state.apiVersion); // now it's a date string

  if (!currentVersion) return false;

  if (target === currentVersion) return true;
  return isAfter(currentVersion, target);
}


